import React from 'react';
import { Col } from 'react-bootstrap';

import Placeholder from 'components/Placeholder';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { UserCard, Username } from '../styles';

const EmailAccountPlaceholder: React.FC = () => {
  const placeholders = [];

  for (let i = 1; i <= 5; i++) {
    placeholders.push(i);
  }

  return (
    <>
      {placeholders.map((p, i) => (
        <Col sm="6" key={i}>
          <UserCard>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <FontAwesomeIcon icon={faUserCircle} />
              <Username>
                <Placeholder width={100} height={12} />
              </Username>
            </div>
          </UserCard>
        </Col>
      ))}
    </>
  );
};

export default EmailAccountPlaceholder;
